import type { TelehealthReportData } from './types';

export const MOCK_REPORT_DATA: TelehealthReportData = {
  patient: {
    patient_id: 'PAT-001',
    patient_name: 'Prueba Report',
    patient_dob: '1994-01-22',
  },
  dates: {
    case_submitted: '2026-01-22T00:00:00Z',
    case_evaluated: '2026-01-22T00:00:00Z',
    case_submitted_formatted: '2026-01-22',
    case_evaluated_formatted: '2026-01-22',
  },
  grade: {
    is_readable: true,
    is_urgent: false,
    grade_version: 2,
    dr_grade_scale: 'MILD',
    dr_grade_string: 'Mild NPDR',
    presence_of_dr: true,
    presence_of_dr_label: 'Visible presence of DR',
    disease_presence: {
      cotton_wool_spots: false,
      hard_exudates: false,
      microaneurysms: false,
      macular_edema: true,
      nvd: false,
      nve: false,
    },
    follow_up: {
      dr_follow_up: 'RETURN_6_MONTHS',
      dr_follow_up_label: 'Return in 6 months',
      other_disease_follow_up: 'RETURN_3_MONTHS',
      other_disease_follow_up_label: 'Return in 3 months',
      combined_label: 'Return in 3 months',
    },
    other_disease_label: 'Macular drusen.',
    macular_edema_label: 'Evidence of diabetic macular edema found.',
    notes_label: 'All images are of sufficient quality. Visible presence of DR.',
  },
  insights: {
    should_include: true,
    images: [
      {
        position_name: 'OD (Right) Macula Centered',
        position_key: 'od_macula',
        category_data: {
          vessel_data: [
            { name: 'A/V Ratio', value: '0.7445', raw_value: '0.744508' },
            { name: 'Fractals', value: '1.5399', raw_value: '1.53992' },
            { name: 'Tortuosity', value: '0.5636', raw_value: '0.563596' },
            { name: 'Vessel Density', value: '0.1049', raw_value: '0.104867' },
          ],
          optic_disc_data: [{ name: 'Od Diam Ratio', value: '1.5421', raw_value: '1.542146' }],
          lesion_data: [
            { name: 'Bright Lesions', value: '0', raw_value: '0' },
            { name: 'Red Lesions', value: '2', raw_value: '2' },
            { name: 'Area', value: '0.0008', raw_value: '0.000765' },
            { name: 'Quadrants', value: '2', raw_value: '2' },
            { name: 'Near Fovea', value: 'No', raw_value: false },
          ],
        },
      },
      {
        position_name: 'OS (Left) Macula Centered',
        position_key: 'os_macula',
        category_data: {
          vessel_data: [
            { name: 'A/V Ratio', value: '0.8969', raw_value: '0.896924' },
            { name: 'Fractals', value: '1.5242', raw_value: '1.524203' },
            { name: 'Tortuosity', value: '0.6963', raw_value: '0.696329' },
            { name: 'Vessel Density', value: '0.1089', raw_value: '0.108905' },
          ],
          optic_disc_data: [],
          lesion_data: [
            { name: 'Bright Lesions', value: '0', raw_value: '0' },
            { name: 'Red Lesions', value: '5', raw_value: '5' },
            { name: 'Area', value: '0.0023', raw_value: '0.002298' },
            { name: 'Quadrants', value: '3', raw_value: '3' },
            { name: 'Near Fovea', value: 'No', raw_value: false },
          ],
        },
      },
      {
        position_name: 'OD (Right) Optic Disc Centered',
        position_key: 'od_optic',
        category_data: {
          vessel_data: [
            { name: 'A/V Ratio', value: '0.7174', raw_value: '0.717381' },
            { name: 'Fractals', value: '1.5379', raw_value: '1.537898' },
            { name: 'Tortuosity', value: '0.6329', raw_value: '0.632891' },
            { name: 'Vessel Density', value: '0.1092', raw_value: '0.109182' },
          ],
          optic_disc_data: [{ name: 'Od Diam Ratio', value: '1.4992', raw_value: '1.499193' }],
          lesion_data: [
            { name: 'Bright Lesions', value: '7', raw_value: '7' },
            { name: 'Red Lesions', value: '1', raw_value: '1' },
            { name: 'Area', value: '0.0021', raw_value: '0.002055' },
            { name: 'Quadrants', value: '2', raw_value: '2' },
            { name: 'Near Fovea', value: 'No', raw_value: false },
          ],
        },
      },
      {
        position_name: 'OS (Left) Optic Disc Centered',
        position_key: 'os_optic',
        category_data: {
          vessel_data: [
            { name: 'A/V Ratio', value: '0.8716', raw_value: '0.871614' },
            { name: 'Fractals', value: '1.4776', raw_value: '1.477606' },
            { name: 'Tortuosity', value: '0.7035', raw_value: '0.703477' },
            { name: 'Vessel Density', value: '0.0922', raw_value: '0.092172' },
          ],
          optic_disc_data: [{ name: 'Od Diam Ratio', value: '1.4644', raw_value: '1.46441' }],
          lesion_data: [
            { name: 'Bright Lesions', value: '1', raw_value: '1' },
            { name: 'Red Lesions', value: '0', raw_value: '0' },
            { name: 'Area', value: '0.0001', raw_value: '0.0001' },
            { name: 'Quadrants', value: '1', raw_value: '1' },
            { name: 'Near Fovea', value: 'No', raw_value: false },
          ],
        },
      },
    ],
    total_images_with_data: 4,
    total_images_processed: 4,
  },
  images: [
    {
      filename: 'od_macula.jpg',
      s3_url: 'https://placehold.co/400x400/000/333?text=OD+Macula',
      label: 'OD (Right) Macula Centered',
      eye_side: 'right',
      eye_side_label: 'OD (Right)',
    },
    {
      filename: 'os_macula.jpg',
      s3_url: 'https://placehold.co/400x400/000/333?text=OS+Macula',
      label: 'OS (Left) Macula Centered',
      eye_side: 'left',
      eye_side_label: 'OS (Left)',
    },
    {
      filename: 'od_optic.jpg',
      s3_url: 'https://placehold.co/400x400/000/333?text=OD+Optic+Disc',
      label: 'OD (Right) Optic Disc Centered',
      eye_side: 'right',
      eye_side_label: 'OD (Right)',
    },
    {
      filename: 'os_optic.jpg',
      s3_url: 'https://placehold.co/400x400/000/333?text=OS+Optic+Disc',
      label: 'OS (Left) Optic Disc Centered',
      eye_side: 'left',
      eye_side_label: 'OS (Left)',
    },
  ],
  case_id: 'CASE-001',
  grade_id: 'GRADE-001',
};
